import React, { useEffect, useState } from "react";
import Button from "./ds/Button";
import Options from "./ds/Options";


export default function TableFooter(props) {
  const [options, setOptions] = useState(false);


  // Options
  useEffect(() => {
    document.body.addEventListener('click', () => setOptions(false));
  }, []);

  function showOptions(e) {
    e.stopPropagation();
    setOptions(true);
  }


  return (
    <div className="footer">
      <p className="t-body-s"><span></span> seleccionados / {props.total} en total</p>

      <div>
        <Button type="secondary" label="Seleccionar" onclick={showOptions} />

        {options && (
          <Options>{props.children}</Options>
        )}
      </div>
    </div>
  )
}